export default "__VITE_ASSET__DMJaO2iz__"